import React from "react";
import { Link } from "react-router-dom";
import Details from "../Common/Details";

const SoldItemsCard = ({ imageUrls, title }) => {
  return (
    <div className="box-border grid grid-cols-5 overflow-hidden rounded-lg border border-lightGray">
      <picture className="aspect-square">
        <img
          src={imageUrls[0] || "https://via.placeholder.com/150"}
          alt=""
          className="aspect-square w-full"
        />
      </picture>

      <div className="col-span-3 flex grow flex-col items-start justify-between px-8 pt-8 pb-10">
        <div>
          <Link to="/auctionlisting">
            <h3 className="font-pop text-2xl font-bold text-darkGreen">
              {title || "Buz Plumbing"}
            </h3>
          </Link>
          <p className="mt-2 mb-4 flex w-4/5 items-end gap-1 font-pop text-sm font-normal text-cardSecondaryColor">
            Lorem ipsum dolor sit amet consectetur. Habitant magna et volutpat
            consectetur. Diam vestibulum rutrum odio amet massa nibh eget
            tellus.
          </p>
        </div>
      </div>
      <Details />
    </div>
  );
};

export default SoldItemsCard;
